"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[221],{

/***/ 7071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ CardList; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(6501);
// EXTERNAL MODULE: ./node_modules/react-icons/bi/index.esm.js
var index_esm = __webpack_require__(9951);
// EXTERNAL MODULE: ./node_modules/react-icons/gi/index.esm.js
var gi_index_esm = __webpack_require__(2585);
// EXTERNAL MODULE: ./node_modules/react-icons/si/index.esm.js
var si_index_esm = __webpack_require__(7735);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/Card.tsx









var ColorMap = function ColorMap(type) {
  switch (type) {
    case 'WTF':
      return 'aqua';

    case 'GitBook':
      return 'cherry';

    case 'Search':
      return 'lemon';

    default:
      return 'white';
  }
};

var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__Wrapper",
  componentId: "sc-dthrq2-0"
})(["width:100%;display:flex;flex-direction:column;border-radius:10px;align-items:center;overflow:hidden;background:", ";@media all and (min-width:726px){flex-direction:row;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primaryLight;
});
var CardContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__CardContent",
  componentId: "sc-dthrq2-1"
})(["align-self:flex-start;flex-grow:1;width:100%;padding:1rem;"]);
var CardImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__CardImage",
  componentId: "sc-dthrq2-2"
})(["display:flex;flex-shrink:0;width:126px;height:126px;background-position:center center;background-repeat:no-repeat;background-size:contain;justify-content:center;align-items:center;padding:10px;@media all (min-width:1024px){height:100%;}"]);
var CardTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "Card__CardTitle",
  componentId: "sc-dthrq2-3"
})(["font-size:2rem;font-weight:200;margin:0 0 5px 0;"]);
var CardDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "Card__CardDescription",
  componentId: "sc-dthrq2-4"
})(["font-size:1rem;margin:3px 0 20px;font-weight:200;display:-webkit-box;line-clamp:2;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;"]);
var CardLink = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "Card__CardLink",
  componentId: "sc-dthrq2-5"
})(["display:flex;justify-content:space-between;align-items:center;font-size:1rem;margin:3px 0;font-weight:200;color:", ";a:hover{text-decoration:underline;}svg{flex-shrink:0;margin-left:10px;cursor:pointer;transition:transform 0.3s ease-in-out;&:hover{transform:scale(1.2) rotate(10deg);}}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
});
var TagWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__TagWrapper",
  componentId: "sc-dthrq2-6"
})(["margin-top:2rem;display:flex;flex-wrap:wrap;gap:10px;"]);
var CardTag = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Card__CardTag",
  componentId: "sc-dthrq2-7"
})(["background:", ";padding:1px 10px;border-radius:10px;color:", ";"], function (_ref3) {
  var type = _ref3.type,
      theme = _ref3.theme;
  return theme.colors[ColorMap(type)];
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primary;
});
var CardTagLink = (0,styled_components_browser_esm/* default */.ZP)(CardTag).withConfig({
  displayName: "Card__CardTagLink",
  componentId: "sc-dthrq2-8"
})(["cursor:pointer;"]);
var Card = function Card(_ref5) {
  var title = _ref5.title,
      description = _ref5.description,
      url = _ref5.url,
      _short = _ref5["short"],
      thumbnail = _ref5.thumbnail,
      _ref5$source = _ref5.source,
      source = _ref5$source === void 0 ? 'WTF' : _ref5$source,
      favicon = _ref5.favicon,
      tags = _ref5.tags;

  var handleCopy = function handleCopy(content) {
    navigator.clipboard.writeText(content);
    dist/* default.success */.ZP.success('Awesome link copied!');
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CardImage, {
      style: {
        backgroundImage: "url(".concat(thumbnail, ")")
      },
      children: [source === 'GitBook' && /*#__PURE__*/(0,jsx_runtime.jsx)(si_index_esm/* SiGitbook */.ZcO, {
        size: 56
      }), source === 'Search' && /*#__PURE__*/(0,jsx_runtime.jsx)(gi_index_esm/* GiPirateFlag */.F_b, {
        size: 56
      }), source === 'WTF' && !thumbnail && /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* BiLink */.Wlb, {
        size: 56
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CardContent, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CardTitle, {
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CardDescription, {
        children: description || 'No description'
      }), url && /*#__PURE__*/(0,jsx_runtime.jsxs)(CardLink, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
          href: url,
          target: "__blank",
          children: [url.slice(0, 50), url.length > 50 && '...']
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* BiCopy */.LhG, {
          onClick: function onClick() {
            return handleCopy(url);
          },
          size: 20
        })]
      }), _short && /*#__PURE__*/(0,jsx_runtime.jsxs)(CardLink, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "/".concat(_short),
          target: "__blank",
          children: _short
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* BiCopy */.LhG, {
          onClick: function onClick() {
            return handleCopy(_short);
          },
          size: 20
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TagWrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CardTag, {
          type: source,
          children: source
        }), tags === null || tags === void 0 ? void 0 : tags.map(function (tag) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/tags/".concat(tag),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardTagLink, {
              children: tag
            })
          }, tag);
        })]
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/CardList.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var CardList_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CardList__Wrapper",
  componentId: "sc-1uck0br-0"
})(["width:100%;padding:1rem 0;display:grid;grid-template-columns:1fr;grid-gap:1rem;@media all and (min-width:1024px){grid-template-columns:repeat(2,1fr);}"]);
var CardList = function CardList(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardList_Wrapper, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [data.length === 0 && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: "/images/no-found.jpg",
        layout: "responsive",
        width: "1280",
        height: "668",
        alt: "Search not found"
      }), data.map(function (item) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread({}, item), item.id);
      })]
    })
  });
};

/***/ }),

/***/ 436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var animejs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6030);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_icons_ri__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9352);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9521);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);





var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Loading__Wrapper",
  componentId: "sc-n7jyk4-0"
})(["width:36px;height:36px;margin:1rem;transform-origin:center;"]);
var Loading = function Loading() {
  var iconRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    (0,animejs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
      targets: iconRef.current,
      rotate: [0, 359],
      duration: 900,
      easing: 'linear',
      loop: true
    });
  }, [iconRef]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Wrapper, {
    ref: iconRef,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_icons_ri__WEBPACK_IMPORTED_MODULE_4__/* .RiLoader4Fill */ .iAc, {
      size: 36
    })
  });
};

/***/ }),

/***/ 5322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ Title; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9521);

var Title = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
  displayName: "Title",
  componentId: "sc-kmln5s-0"
})(["font-size:4rem;font-weight:600;margin:0 0 1rem 0;padding:0;"]);

/***/ }),

/***/ 6912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layout_Main; }
});

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./src/components/Loading.tsx
var Loading = __webpack_require__(436);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/ULIcon.tsx


var ULIcon = function ULIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 39 37",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      id: "Artboard1",
      x: "0",
      y: "0",
      width: "38.582",
      height: "36.684",
      style: {
        fill: 'none'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
      id: "_clip1",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "0",
        y: "0",
        width: "38.582",
        height: "36.684"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      "clip-path": "url(#_clip1)",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          x: "27.337",
          y: "-0.141",
          width: "11.295",
          height: "28.362",
          style: {
            fill: '#fcd34d',
            fillRule: 'nonzero'
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M11.452,28.222l0,-28.363l-11.295,0l0,36.995l27.172,0l0,-8.632l-15.877,-0Z",
          style: {
            fill: '#6ee7b7',
            fillRule: 'nonzero'
          }
        })]
      })
    })]
  });
};
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-icons/bs/index.esm.js
var index_esm = __webpack_require__(3750);
// EXTERNAL MODULE: ./node_modules/react-icons/gi/index.esm.js
var gi_index_esm = __webpack_require__(2585);
// EXTERNAL MODULE: ./node_modules/react-icons/hi/index.esm.js
var hi_index_esm = __webpack_require__(3854);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5434);
;// CONCATENATED MODULE: ./src/components/Menu.tsx









var Wrapper = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
  displayName: "Menu__Wrapper",
  componentId: "sc-17x7t2q-0"
})(["position:relative;width:36px;height:100%;padding:2rem;display:flex;flex-direction:column;justify-content:flex-start;align-items:center;gap:1rem;"]);
var Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "Menu__Button",
  componentId: "sc-17x7t2q-1"
})(["padding:0;margin:0;background:none;border:none;cursor:pointer;outline:none;color:", ";transition:transform 0.3s ease-in-out;&:focus{outline:none;}&:hover{transform:scale(1.2) rotate(10deg);}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.white;
});
var AquaButton = (0,styled_components_browser_esm/* default */.ZP)(Button).withConfig({
  displayName: "Menu__AquaButton",
  componentId: "sc-17x7t2q-2"
})(["color:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.aqua;
});
var CherryButton = (0,styled_components_browser_esm/* default */.ZP)(Button).withConfig({
  displayName: "Menu__CherryButton",
  componentId: "sc-17x7t2q-3"
})(["color:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.cherry;
});
var LemonButton = (0,styled_components_browser_esm/* default */.ZP)(Button).withConfig({
  displayName: "Menu__LemonButton",
  componentId: "sc-17x7t2q-4"
})(["color:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.lemon;
});
var Menu = function Menu(_ref5) {
  var onToggleSearch = _ref5.onToggleSearch;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button, {
      type: "button",
      onClick: function onClick() {
        return onToggleSearch();
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdSearch */.vU7, {
        size: 28
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: "/",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(hi_index_esm/* HiHome */.g3P, {
          size: 28
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: "/add",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(AquaButton, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(hi_index_esm/* HiPlus */.b9W, {
          size: 28
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: "/loved",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CherryButton, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(hi_index_esm/* HiHeart */.dOX, {
          size: 28
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: "/tags",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LemonButton, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(hi_index_esm/* HiTag */.IFg, {
          size: 28
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: "/roadmap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(gi_index_esm/* GiMountainRoad */.JM3, {
          size: 28
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: "http://universallauncher.com",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        target: "_blank",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button, {
          style: {
            width: '24px'
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ULIcon, {})
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: "http://getgratz.com",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        target: "_blank",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button, {
          style: {
            width: '24px'
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* BsArrowUpCircle */.FKi, {
            size: 28
          })
        })
      })
    })]
  });
};
// EXTERNAL MODULE: ./node_modules/animejs/lib/anime.es.js
var anime_es = __webpack_require__(6030);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/components/SearchBar.tsx







var SearchBar_Wrapper = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
  displayName: "SearchBar__Wrapper",
  componentId: "sc-18s0p81-0"
})(["position:relative;overflow:hidden;display:flex;width:100%;height:0;justify-content:center;background:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.white;
});
var InputGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SearchBar__InputGroup",
  componentId: "sc-18s0p81-1"
})(["width:100%;display:flex;justify-content:space-between;align-items:center;padding:1rem 2rem;color:", ";transform:translateY(-100);"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
});
var InputText = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "SearchBar__InputText",
  componentId: "sc-18s0p81-2"
})(["width:100%;padding:1rem;font-size:3rem;font-weight:200;color:", ";background:none;border:none;outline:none;&:focus{outline:none;}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.primary;
});
var ButtonClose = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "SearchBar__ButtonClose",
  componentId: "sc-18s0p81-3"
})(["border:none;background:none;outline:none;cursor:pointer;transition:transform 0.3s ease-in-out;&:focus{outline:none;}&:hover{transform:scale(1.2) rotate(10deg);}"]);
var SearchBar = function SearchBar(_ref4) {
  var value = _ref4.value,
      open = _ref4.open,
      onChange = _ref4.onChange,
      onToggle = _ref4.onToggle;
  var router = (0,next_router.useRouter)();
  var wrapperRef = (0,react.useRef)(null);
  var groupRef = (0,react.useRef)(null);
  var inputRef = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    (0,anime_es/* default */.Z)({
      targets: wrapperRef.current,
      height: open ? 106 : 0,
      duration: 300,
      delay: open ? 0 : 50,
      easing: 'easeInOutQuart'
    });
    (0,anime_es/* default */.Z)({
      targets: groupRef.current,
      translateY: open ? 0 : -100,
      duration: 300,
      delay: open ? 50 : 0,
      easing: 'easeInOutQuart'
    });

    if (open) {
      var _inputRef$current;

      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
    }
  }, [open]);

  var handleChange = function handleChange(event) {
    event.preventDefault();
    var target = event.target;
    onChange(target.value);
  };

  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    router.push("/?q=".concat(value));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(SearchBar_Wrapper, {
    ref: wrapperRef,
    onSubmit: handleSubmit,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(InputGroup, {
      ref: groupRef,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdSearch */.vU7, {
        size: 36
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(InputText, {
        ref: inputRef,
        placeholder: "SEARCH HERE",
        value: value,
        onChange: handleChange
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonClose, {
        type: "button",
        onClick: function onClick() {
          return onToggle(false);
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdClose */.FU5, {
          size: 36
        })
      })]
    })
  });
};
// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(3299);
;// CONCATENATED MODULE: ./src/components/User.tsx





var User_Wrapper = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
  displayName: "User__Wrapper",
  componentId: "sc-h2t4k3-0"
})(["position:relative;width:36px;padding:2rem;display:flex;flex-direction:column;justify-content:flex-start;align-items:center;"]);
var Profile = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "User__Profile",
  componentId: "sc-h2t4k3-1"
})(["width:40px;height:40px;border-radius:50%;border:2px solid ", ";outline:none;background-color:", ";background-image:url(", ");background-position:center center;background-repeat:none;background-size:cover;color:", ";font-size:1rem;font-weight:700;cursor:pointer;transition:transform 0.3s ease-in-out;&:focus{outline:none;}&:hover{transform:scale(1.2) rotate(10deg);}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.white;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
}, function (props) {
  return props.avatar;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.primary;
});
var Me = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "User__Me",
  componentId: "sc-h2t4k3-2"
})(["position:absolute;top:20px;right:70px;background:", ";border-radius:10px;padding:1rem 0 0 0;color:", ";overflow:hidden;p{margin:0;padding:0 1rem;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.white;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.primary;
});
var User_Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "User__Button",
  componentId: "sc-h2t4k3-3"
})(["width:100%;border:none;background:none;outline:none;cursor:pointer;margin:1rem 0 0;padding:0.5rem 1rem;font-weight:600;background:", ";color:", ";&:focus{outline:none;}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.cherry;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.white;
});
var User = function User() {
  var _session$user, _session$user2, _session$user3;

  var _useSession = (0,next_auth_react.useSession)(),
      session = _useSession.data;

  var _useState = (0,react.useState)(false),
      open = _useState[0],
      setOpen = _useState[1];

  var meRef = (0,react.useRef)(null);

  var handleLogout = function handleLogout(event) {
    event.preventDefault();
    (0,next_auth_react.signOut)();
  }; // useEffect(() => {
  //   if (!meRef.current) {
  //     return;
  //   }
  //   anime({
  //     targets: meRef.current,
  //     top: 10,
  //     opacity: [0, 1],
  //     duration: 300,
  //     delay: 50,
  //     easing: 'easeInOutQuart',
  //   });
  // }, [meRef]);


  return /*#__PURE__*/(0,jsx_runtime.jsxs)(User_Wrapper, {
    children: [session && /*#__PURE__*/(0,jsx_runtime.jsx)(Profile, {
      avatar: session === null || session === void 0 ? void 0 : (_session$user = session.user) === null || _session$user === void 0 ? void 0 : _session$user.image,
      onClick: function onClick() {
        return setOpen(!open);
      }
    }), open && /*#__PURE__*/(0,jsx_runtime.jsxs)(Me, {
      ref: meRef,
      onMouseLeave: function onMouseLeave() {
        return setOpen(false);
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: session === null || session === void 0 ? void 0 : (_session$user2 = session.user) === null || _session$user2 === void 0 ? void 0 : _session$user2.name
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: session === null || session === void 0 ? void 0 : (_session$user3 = session.user) === null || _session$user3 === void 0 ? void 0 : _session$user3.email
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(User_Button, {
        onClick: handleLogout,
        children: "Logout"
      })]
    })]
  });
};
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(6501);
;// CONCATENATED MODULE: ./src/layout/Main.tsx












var Main_Wrapper = styled_components_browser_esm/* default.main.withConfig */.ZP.main.withConfig({
  displayName: "Main__Wrapper",
  componentId: "sc-nf7c7g-0"
})(["width:100%;min-height:calc(100vh - 48px);display:flex;justify-content:space-between;padding:1rem;"]);
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Main__Content",
  componentId: "sc-nf7c7g-1"
})(["width:100%;height:100%;display:flex;flex-direction:column;justify-content:flex-start;padding:0 2rem;"]);
var Footer = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
  displayName: "Main__Footer",
  componentId: "sc-nf7c7g-2"
})(["width:100%;height:100%;display:flex;justify-content:center;padding:1rem 2rem;"]);

var Main = function Main(_ref) {
  var children = _ref.children;

  var _useSession = (0,next_auth_react.useSession)(),
      session = _useSession.data,
      status = _useSession.status;

  var loading = status === 'loading';
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(''),
      searchQuery = _useState[0],
      setSearchQuery = _useState[1];

  var _useState2 = (0,react.useState)(false),
      searchOpen = _useState2[0],
      setSearchOpen = _useState2[1];

  var checkQuery = function checkQuery() {
    var _router$query = router.query,
        q = _router$query.q,
        f = _router$query.f;
    var word = Array.isArray(q) ? q[0] : q;
    setSearchOpen(!!word);
    setSearchQuery(word || '');

    if (f) {
      dist/* default.error */.ZP.error('Ops!! Redirect not found!!');
      (0,dist/* default */.ZP)("Searching for you: ".concat(word));
    }
  };

  (0,react.useEffect)(function () {
    if (!session && !loading) {
      router.push('/login');
    }
  }, [session, loading]);
  (0,react.useEffect)(function () {
    checkQuery();
  }, []);
  (0,react.useEffect)(function () {
    checkQuery();
  }, [router.isReady, router.query]);

  if (loading) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Loading/* Loading */.g, {});
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SearchBar, {
      value: searchQuery,
      open: searchOpen,
      onChange: setSearchQuery,
      onToggle: setSearchOpen
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Main_Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Menu, {
        onToggleSearch: function onToggleSearch() {
          return setSearchOpen(!searchOpen);
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Content, {
        children: children
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(User, {})]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer, {
      children: "Made with \u2764 by AE Studio"
    })]
  });
};

/* harmony default export */ var layout_Main = (Main);

/***/ })

}]);